module.exports = __webpack_public_path__ + "static/media/tennis.94298099.jpg";